<template>
    <div class="form-container" ref="contactForm">
    <form @submit.prevent="sendContactMessage">
        <div class="form-row">
            <div class="col-md-12">
                <p>¿Que desea hacer? Escoja una opción</p>
            </div>
        </div>
        <div class="form-row">
            <div class="col-md-12">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn active">Consúltenos</button>
                    <button @click="changeRoute" type="button" class="btn">Cotizar</button>
                </div>
            </div>
        </div>
        <h2>Consúltenos</h2>
        <div class="form-row">
            <div class="col-md-12">
                <p>Datos personales para el envío de la información</p>
            </div>
        </div>
        <div class="form-row">
            <div class="col-md-6">
                <input required type="text" v-model="contactMessage.name" class="form-control" id="inputName" placeholder="Nombre">
            </div>
            <div class="col-md-6">
                <input required type="text" v-model="contactMessage.lastName" class="form-control" id="inputLastName" placeholder="Apellido">
            </div>
        </div>
        <div class="form-row">
            <div class="col-md-12">
                <input required type="email" v-model="contactMessage.email" class="form-control" id="inputEmail" placeholder="Email">
            </div>
        </div>
        <div class="form-row">
            <div class="col-md-12">
                <p>¿Como podemos ayudarle?</p>
            </div>
        </div>
        <div class="form-row">
            <div class="col-md-12">
                <textarea required class="form-control" v-model="contactMessage.message" id="exampleFormControlTextarea1" rows="5"></textarea>
            </div>
        </div>
        <button type="submit" class="default-button default-button-form">Enviar</button>
    </form>
</div>
</template>

<script>
export default {
    data() {
        return {
            contactMessage: {
                name: '',
                lastName: '',
                email: '',
                message: ''
            }
        }
    },
    mounted() {
        console.log(this.$router);
    },
    methods: {
        changeRoute() {
            window.location.href = '/calcule-o-cotice-sus-costos-de-envio';
        },
        sendContactMessage() {
            let loader = this.$loading.show({
                container: this.$refs.contactForm
            });
            var email = {};
            email.subjectMail = 'Mensaje de contacto CRBOX';
            email.formName = 'contactenos';
            email.bodyMail = `<p><strong>De:</strong> ${this.contactMessage.name} ${this.contactMessage.lastName}</p>
            <p><strong>Email:</strong> ${this.contactMessage.email}</p>
            <p><strong>Mensaje: </strong>
            ${this.contactMessage.message}</p>`;

            this.$http.post(window.location.origin + '/wp-json/crbox/v1/sendEmail', email)
            .then((response) => {
                if(response.data){
                    this.$notify({
                        group: 'notifications',
                        type: 'success',
                        title: 'Correo enviado',
                        text: 'Correo enviado satisfactoriamente!',
                        duration: 4000,
                        speed: 1000
                    });
                    this.contactMessage = {
                        name: '',
                        lastName: '',
                        email: '',
                        message: ''
                    }
                }else{
                    this.$notify({
                        group: 'notifications',
                        type: 'error',
                        title: 'Correo',
                        text: 'Ocurrió un error al enviar el correo',
                        duration: 4000,
                        speed: 1000
                    });
                }
                loader.hide();
            })
            .catch(()=>{
                this.$notify({
                    group: 'notifications',
                    type: 'error',
                    title: 'Correo',
                    text: 'Ocurrió un error al enviar el correo',
                    duration: 4000,
                    speed: 1000
                });
                loader.hide();
            })
        }
    }
}
</script>

